import Vue from "vue";

const HasRole = (Vue.prototype.$hasRole = function(roles, currentRole) {
  return roles.includes(parseInt(currentRole));
});

Object.byString = function(o, s) {
  let a = s.split(".");
  for (let i = 0, n = a.length; i < n; ++i) {
    let k = a[i];
    if (o && k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

export { HasRole };
